export const ProductActionTypes = {
  SET_ACTIVE_PLANS: 'SET_ACTIVE_PLANS',
  SET_GRAFANA_DATA: 'SET_GRAFANA_DATA',
  REFRESH_PRODUCT_DATA: 'REFRESH_PRODUCT_DATA',
};
